import React from "react"
import { AppFunctionComponent } from "../../types"
import styled from "styled-components"
import RichText from "../../resolvers/rich-text/rich-text.resolver"
import { ContentfulSection } from "../../types"
import { PrimaryHeading } from "../common/heading.component"
import Newsletter from "../common/newsletter.component"
import {
  FullSection,
  SectionArticle,
  SectionLayout,
} from "../common/sections/section.component"

export const ScrollHandler = styled.span`
  position: absolute;
  top: -90px;
`

export const NewsletterContainer = styled(Newsletter)`
  max-width: 600px;
  margin: 50px auto 0 auto;
`

interface NewsletterProps {
  split?: boolean
  channel: string
  defaultContent: ContentfulSection
}

const NewsletterSection: AppFunctionComponent<NewsletterProps> = ({
  split = true,
  channel = "Mudita website - Footer",
  defaultContent,
}) => {
  const { title, text } = defaultContent
  return (
    <FullSection layout={SectionLayout.Newsletter}>
      <ScrollHandler id={"newsletter"} />
      <SectionArticle>
        <PrimaryHeading renderAs={"div"}>{title}</PrimaryHeading>
        {text && <RichText content={text} />}
        <NewsletterContainer split={split} channel={channel} />
      </SectionArticle>
    </FullSection>
  )
}

export default NewsletterSection
